import "./BackgroundImage.scss";
import React from "react";

const BackgroundImage: React.FC = () => {
  return <div className="background-image" />;
};

export default BackgroundImage;
